import {
  store,
  getElement
} from '@wordpress/interactivity';

const getInitialState = () => {
  const savedRecentSearches = localStorage.getItem('recentSearches');

  return {
    recent_searches: savedRecentSearches ? JSON.parse(savedRecentSearches) : []
  };
};

const { state } = store('instantSearch', {
  state: getInitialState(),
  
  actions: {
    isAnyResults() {
      return state.matched_posts?.length > 0 || state.search.length > 0;
    },
    isAnyRecentSearches() {
      return state.recent_searches.length > 0 && state.search.length === 0;
    },
    removeRecentSearch() {
      const { ref } = getElement();

      if (!ref) {
        console.error('Element reference is undefined.');
        return;
      }

      const url = ref.getAttribute('url');

      if (!url) {
        console.error('URL attribute is missing or undefined.');
        return;
      }

      const newRecentSearches = state.recent_searches.filter(search => search.url !== url);

      if (newRecentSearches.length !== state.recent_searches.length) {
        state.recent_searches = newRecentSearches;
        localStorage.setItem('recentSearches', JSON.stringify(newRecentSearches));
      }
    },

    clearRecentSearches() {
      state.recent_searches = [];
      localStorage.removeItem('recentSearches');
    }
  }
});